<app-spinner></app-spinner>

<div class="mx-auto" style="width: 82%">

  <h1 *ngIf="!this.recreateindexsuccess && this.recreateindexsuccess !== undefined" class="text-center"
      style="color: red">Fehler beim neuerstellen des kompletten Suchindex</h1>
  <h1 *ngIf="this.recreateindexsuccess" class="text-center" style="color: green">Alle Suchindexe neu erstellt</h1>

  <a routerLink="/admin/recruitform/create/">
    <button type="button" class="btn btn-primary mb-5">Bewerberprofil Erstellen</button>
  </a>

  <a class="ms-2" (click)="this.recreateIndex()">
    <button type="button" class="btn btn-warning mb-5">Alle Suchindexe neu erstellen</button>
  </a>

  <table class="table top">
    <thead>
    <tr>
      <th scope="col" class="pointer" (click)="this.sortTablebyColum('uuid')">
        UUID    <i *ngIf="this.lastsort === 'uuid'"
                   [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                   class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('title')">
        Title    <i *ngIf="this.lastsort === 'title'"
                    [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                    class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('published')">Veröffentlicht <i
        *ngIf="this.lastsort === 'published'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th>Aktionen</th>
    </tr>
    </thead>
    <tbody>
    <tr (click)="Helper.TableSelect($event)" *ngFor="let recruit of this.recruits | async" id="{{recruit.uuid}}">
      <td>{{ recruit.uuid }}</td>
      <td>{{ recruit.title }}</td>
      <td>
        <input type="checkbox" name="" id="checkbox{{recruit.uuid}}"
               [disabled]="!PermissionsHelper.hasPermission('staff.recruit.edit')" class="checkbox-slider"
               (click)="this.changePublishedStatus($event,recruit.uuid)" [checked]="recruit.published">
        <label for="checkbox{{recruit.uuid}}"></label>
      </td>
      <td>
        <button class="btn btn-primary me-2" [disabled]="!PermissionsHelper.hasPermission('staff.recruit.edit')"
                (click)="this.router.navigateByUrl('/admin/recruitform/edit/' + recruit.uuid)">Job Bearbeiten
        </button>
        <button class="btn btn-warning" (click)="this.recreateIndex(recruit.uuid)"
                [disabled]="!PermissionsHelper.hasPermission('staff.index.renew')">Suchindex neu erstellen
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
